import axios from 'axios';
import { clearAuthSession, getAccessToken } from '../utils/authStorage';

const baseURL = process.env.REACT_APP_API_URL || 'https://api.vidyakasam.in/v1';

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

function notifyAuthSessionEnded(message = '', sessionContext = null) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent('vidya-kasam:auth-session-ended', {
      detail: {
        message,
        sessionContext,
      },
    })
  );
}

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    if (process.env.REACT_APP_APP_KEY) {
      config.headers['X-App-Key'] = process.env.REACT_APP_APP_KEY;
    }

    if (typeof window !== 'undefined' && window.location?.origin) {
      config.headers['X-Site-Url'] = window.location.origin;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error || new Error('Unknown request error'));
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    let errorMessage = 'An unexpected error occurred';
    const responseData = error.response?.data;

    if (error.response) {
      errorMessage =
        responseData?.message ||
        responseData?.dataset?.data?.message ||
        `Server error: ${error.response.status}`;

      if (error.response.status === 401) {
        clearAuthSession();
        notifyAuthSessionEnded(errorMessage, responseData?.session_context || null);
      }
    } else if (error.request) {
      errorMessage = 'Network error: Unable to reach the server';
    } else {
      errorMessage = error.message || 'Request setup error';
    }

    error.message = errorMessage;
    error.backend = responseData;

    return Promise.reject(error);
  }
);

export default api;
